/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/

// Subscription tier ranking.
// Higher rank = higher tier. Legacy svip/vip/ssvip map to the modern
// plus/pro/max ladder so existing paying users keep their access without
// migration.
export const TIER_RANK: Record<string, number> = {
  plus: 1,
  svip: 1,
  pro: 2,
  vip: 2,
  max: 3,
  ssvip: 3,
}

export function rankOf(group: string | undefined | null): number {
  if (!group) return 0
  return TIER_RANK[group.toLowerCase()] ?? 0
}
